export default __webpack_public_path__ + "static/media/curation4.3e04cd8f.mp3";